import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component for on-device rep-recap dictation (CONEK-4035 Task M6.1).
//
// On Android the native RecapDictationBridgeComponent receives the recorded
// audio path, runs whisper.cpp large-v3-turbo on-device, and replies with the
// transcript. The controller fills the `name="recap"` textarea with the
// result so the rep can edit before hitting "Draft with AI".
//
// Graceful degradation: when no bridge is present (browser, iOS) every method
// is a no-op and the textarea continues to work as a plain typed field.
export default class extends BridgeComponent {
  static component = "recap-dictation"

  static targets = ["dictateButton", "recapTextarea"]

  connect() {
    super.connect()
    this.send("connect", {})
  }

  // Called from the microphone button in _ai_draft.html.erb via
  // data-action="bridge--recap-dictation#dictate".
  dictate() {
    this.send("start_dictation", {}, (message) => {
      this.handleTranscriptionComplete(message)
    })
  }

  handleTranscriptionComplete(message) {
    if (!message) return

    // The bridge callback receives the full message envelope
    // {id, component, event, data: {...}}.
    const data =
      message.data !== null &&
      message.data !== undefined &&
      typeof message.data === "object"
        ? message.data
        : message

    if (!data || data.action !== "transcription_complete") return

    const transcript = data.transcript
    if (!transcript) return

    // Find the recap textarea. Prefer the declared Stimulus target; fall
    // back to a `name="recap"` lookup within the controller element so the
    // bridge still works if the partial omits the target attribute.
    const textarea = this.hasRecapTextareaTarget
      ? this.recapTextareaTarget
      : this.element.querySelector("textarea[name='recap']")

    if (!textarea) return

    textarea.value = transcript

    // Dispatch `input` so Turbo / Rails UJS / any upstream listener knows
    // the field changed (mirrors the pattern used by call_log_controller.js).
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
